<div class="locker-location-page">
  <div class="container locker-location-shell">
    <section class="locker-location-panel">
      <div class="locker-location-header">
        <span class="locker-location-step">1.</span>
        <div>
          <h2>{{'reserve.location.title'|traduccion}}</h2>
          <p>{{'reserve.location.instruction'|traduccion}}</p>
        </div>
      </div>

      @if (locations.length) {
        <div class="locker-location-content">
          <div class="locker-map-card">
            <div class="locker-map-frame">
              <div #mapContainer class="locker-map-canvas" role="region" [attr.aria-label]="'reserve.locationMap'|traduccion"></div>
            </div>
            @if (selectedLocation) {
              <div class="locker-map-footer">
                <div>
                  <strong>{{ selectedLocation.name }}</strong>
                  <p>{{ selectedLocation.addressLine }}</p>
                </div>
                <button
                  type="button"
                  class="btn locker-cta locker-cta-mobile"
                  [disabled]="isReserving"
                  (click)="reserveLocation(selectedLocation)">
                  {{'reserve.location.reserveHere'|traduccion}}
                </button>
              </div>
            }
          </div>
          <div class="locker-location-list">
            @for (location of locations; track trackByLocation($index, location)) {
              <button
                type="button"
                class="locker-location-item"
                [class.active]="selectedLocation?.id === location.id"
                (click)="selectLocation(location)">
                <div class="locker-location-item__marker"></div>
                <div class="locker-location-item__body">
                  <h3>{{ location.name }}</h3>
                  <p>{{ location.addressLine }}</p>
                  @if (location.cityLine) {
                    <p>{{ location.cityLine }}</p>
                  }
                </div>
              </button>
            }
            @if (selectedLocation) {
              <button
                type="button"
                class="btn locker-cta locker-cta-desktop"
                [disabled]="isReserving"
                (click)="reserveLocation(selectedLocation)">
                {{'reserve.location.reserveAt'|traduccion}} {{ selectedLocation.name }}
              </button>
            }
          </div>
        </div>
      } @else {
        <div class="locker-location-empty">
          <p>{{'reserve.location.empty'|traduccion}}</p>
        </div>
      }
    </section>
  </div>
</div>
